module.exports = __webpack_public_path__ + "img/brand6.fdd66752.png";